"use strict";

/**
 * Parent module for all modules in Api/
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ISurveyInfo = exports.ISurveyComponent = exports.ISurvey = exports.IFloodgateSettingIdMap = exports.IFloodgateStorageProvider = exports.IActivityListener = void 0;
var ISurveyInfo = require("./../ISurveyInfo");
exports.ISurveyInfo = ISurveyInfo;
var IActivityListener = require("./IActivityListener");
exports.IActivityListener = IActivityListener;
var IFloodgateSettingIdMap = require("./IFloodgateSettingIdMap");
exports.IFloodgateSettingIdMap = IFloodgateSettingIdMap;
var IFloodgateStorageProvider = require("./IFloodgateStorageProvider");
exports.IFloodgateStorageProvider = IFloodgateStorageProvider;
var ISurvey = require("./ISurvey");
exports.ISurvey = ISurvey;
var ISurveyComponent = require("./ISurveyComponent");
exports.ISurveyComponent = ISurveyComponent;
var CampaignDefinitionProvider_1 = require("../Campaign/CampaignDefinitionProvider");
Object.defineProperty(exports, "CampaignDefinition", {
  enumerable: true,
  get: function () {
    return CampaignDefinitionProvider_1.CampaignDefinition;
  }
});